import React from "react";
import { notBlank } from "../../../util/ext";
import { usePrincipalName } from "../../mediaAccessServices";

import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";

const PrincipalCard = ({ principal }) => {
  const name = usePrincipalName(principal);
  return (
    <Box>
      {notBlank(name) && (
        <Typography style={{ fontWeight: "bold", fontSize: "1.7rem" }}>
          {name}
        </Typography>
      )}

      <Typography variant="subtitle2">{principal}</Typography>
    </Box>
  );
};

export default PrincipalCard;
